<template>
  <Teleport to="body">
    <div v-if="isVisible" class="image-viewer">
      <div class="image-viewer__menu">
        <BaseButtonIcon
          icon-name="vuesax:close-linear"
          icon-color="var(--color-foreground-inverted)"
          variant="dark"
          @click="isVisible = false"
        />
      </div>
      <BaseCarousel
        v-if="props.srcList.length > 1"
        v-model:selected-index="selectedIndex"
        :items="props.srcList"
        object-fit="contain"
        class="image-viewer__carousel"
        @update:selected-index="selectedIndex = $event"
      >
        <template #slide="{ item }">
          <div class="image-viewer__item">
            <div
              class="image-viewer__background"
              :style="{
                backgroundImage: `url(${item})`,
              }"
            />
            <BaseImage :src="item" :with-cross-origin="false" object-fit="contain" />
          </div>
        </template>
      </BaseCarousel>
      <div v-else class="image-viewer__item">
        <div
          class="image-viewer__background"
          :style="{
            backgroundImage: `url(${props.srcList[0]})`,
          }"
        />
        <BaseImage :src="props.srcList[0]" :with-cross-origin="false" object-fit="contain" />
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import BaseButtonIcon from '../button-icon/index.vue'
import BaseCarousel from '../carousel/index.vue'
import BaseImage from '../image/index.vue'

interface Props {
  srcList: string[]
}

const props = defineProps<Props>()

const selectedIndex = defineModel<number>('selectedIndex', { default: 0 })

const isVisible = defineModel<boolean>('visible', { default: false })
</script>

<style lang="scss" scoped>
.image-viewer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background-color: rgb(0 0 0 / 30%);
  backdrop-filter: blur(4px);

  &__background {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(20px);
    transform: scale(1.4);
  }

  &__menu {
    position: absolute;
    top: rem(20px);
    right: rem(20px);
    z-index: 2;
    display: flex;
    align-items: center;
    gap: rem(10px);
  }

  &__carousel {
    height: 100%;
  }

  &__item {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
